/**
 * PPME Hooks for using the /external routes
 */

import { postMessageUp } from 'iframe-support'

export default {
  sessionTimerOverlayRenderedHook() {
    postMessageUp({ statusMessage: 'sessionTimerOverlayRendered' })
  },

  previewPageSendSubmitHook() {
    postMessageUp({ statusMessage: 'previewPageSendAction' })
  },

  successPageAfterRenderHook(props = {}) {
    // TODO: make sure this value does actually exist ever
    if (props.complianceInfo.status !== 'PENDING') {
      postMessageUp({
        statusMessage: 'successPageRendered',
        data: {
          name: props.displayName,
          amount: props.amountFormatted,
        },
      })
    }
  },

  loadingStateChangedHook({ isLoading }) {
    postMessageUp({ toggleLoading: isLoading })
  },
}
